import script from "./AdminPanelView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminPanelView.vue?vue&type=script&lang=ts&setup=true"

import "./AdminPanelView.vue?vue&type=style&index=0&id=2ee11f7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee11f7a"]])

export default __exports__